import { useMount } from 'react-use';
import { redirectToAuth } from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';

import { Alert, AlertTitle, Icon, VStack } from '@eluve/components';
import { clearSkippedInterstitials } from '@eluve/interstitials';
import { usePostHog } from '@eluve/posthog-react';

export const LogoutPage: React.FC = () => {
  const posthog = usePostHog();

  const handleLogout = async () => {
    clearSkippedInterstitials();
    posthog?.reset();
    await Session.signOut();
    await redirectToAuth({
      redirectBack: false,
    });
  };

  useMount(handleLogout);

  return (
    <VStack className="min-h-screen items-center justify-center p-4">
      <Alert className="flex max-w-md items-center gap-2" variant="default">
        <div>
          <Icon name="Loader2Icon" className="animate-spin" />
        </div>
        <AlertTitle>Signing out...</AlertTitle>
      </Alert>
    </VStack>
  );
};
